import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

const MainLayout = () => {
  const isSpinnerActive = useSelector(
    (state) => state.spinnerReducer.spinnerActive
  );

  return (
    <div id="layout-wrapper">
      {/* Spinner Overlay */}
      {isSpinnerActive && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
            flexDirection: "column",
            color: "#fff",
            fontFamily: "sans-serif",
          }}
        >
          <div className="spinner-glow">
            <Spinner
              animation="border"
              variant="light"
              role="status"
              style={{ width: "4rem", height: "4rem" }}
            >
              {/* <span className="visually-hidden">Loading...</span> */}
            </Spinner>
          </div>
          {/* <p style={{ marginTop: "15px", fontSize: "1.2rem" }}>Loading...</p> */}
        </div>
      )}

      {/* Layout */}
      <Header />
      <Sidebar />
      <div className="vertical-overlay" />
      <div className="main-content">
        <div className="page-content ps-3 pe-3 ps-lg-4 pe-lg-4">
          <Outlet />
        </div>
      </div>

      {/* Extra CSS for glowing animation and layout framing */}
      <style jsx="true">{`
        .spinner-glow {
          display: inline-block;
          animation: pulse 1.5s infinite;
        }
        @keyframes pulse {
          0% {
            transform: scale(1);
            filter: drop-shadow(0 0 5px #0d6efd);
          }
          50% {
            transform: scale(1.2);
            filter: drop-shadow(0 0 20px #0d6efd);
          }
          100% {
            transform: scale(1);
            filter: drop-shadow(0 0 5px #0d6efd);
          }
        }
        .main-content {
          background: #f3f3f9 !important;
          min-height: 100vh !important;
          display: flex !important;
          flex-direction: column !important;
        }
        .page-content {
          background: #ffffff !important;
          border-radius: 12px !important;
          margin: 5px !important;
          margin-top: 75px !important;
          padding: 20px !important;
          min-height: calc(100vh - 145px) !important;
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.02) !important;
          flex-grow: 1 !important;
        }
      `}</style>
    </div>
  );
};

export default MainLayout;
